<template>
  <v-dialog
    width="unset"
    v-model="open"
    @click:outside="closeDialog()"
  >
    <v-card class="detailsCard">
      <div class="pa-2 detailsCard__title">
        <img
          src="@/assets/kanna1.png"
          height="100"
          alt="details"
        />
        <span class="detailsCard__title--text">Details</span>
        <div class="d-flex">
          <v-icon
            color="white"
            x-large
            class="detailsCard__close"
            @click="closeDialog()"
            >mdi-close</v-icon
          >
        </div>
      </div>

      <v-list>
        <v-list-item class="detailsCard__list">
          <v-list-item-content>
            <v-list-item-title>Artist:</v-list-item-title>
            <v-list-item-subtitle>{{ pictureDetails.artist }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Character:</v-list-item-title>
            <v-list-item-subtitle
              v-html="pictureDetails.character"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <template>
            <v-list-item-action v-if="this.options.target === 'wallheaven'">
              <v-btn @click="moreLikeThis(pictureDetails.id)">
                <v-icon> mdi-magnify-plus-outline</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>ID:</v-list-item-title>
              <v-list-item-subtitle v-html="pictureDetails.id"> </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Pixiv ID:</v-list-item-title>
            <v-list-item-subtitle>
              <a href="pictureDetails.pixiv_id_url">
                {{ pictureDetails.pixiv_id_url }}
              </a>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Category:</v-list-item-title>
            <v-list-item-subtitle
              v-html="pictureDetails.source.category"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Resolution:</v-list-item-title>
            <v-list-item-subtitle
              v-html="pictureDetails.source.resolution"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Purity/Rating:</v-list-item-title>
            <v-list-item-subtitle
              v-html="pictureDetails.source.purity || pictureDetails.rating"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Source:</v-list-item-title>
            <v-list-item-subtitle>
              <a
                :href="pictureDetails.source_url"
                target="_blank"
                >{{ pictureDetails.source_url }}
              </a>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Tags:</v-list-item-title>
            <v-list-item-subtitle color="grey lighten-2">
              <div v-if="isLoadingTags">Carregando...</div>
              <div
                class="tagsItems"
                v-else
              >
                <a
                  v-for="tag in tags"
                  :key="tag"
                  class=""
                  @click.prevent="searchByTag(tag)"
                >
                  {{ tag }}
                </a>
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import { wallheavenTags } from '@/services/connectBFF'
import { mapState } from 'vuex'

export default {
  name: 'DetailsModal',

  props: {
    dialog: Boolean
  },

  data() {
    return {
      open: false,
      isLoadingTags: false
    }
  },

  computed: {
    ...mapState('options', ['options']),
    ...mapState('listPictures', ['pictureDetails']),

    tags() {
      if (this.options.target === 'civitai') {
        return this.pictureDetails.tags.split(',')
      } else {
        return this.pictureDetails.tags.split(' ')
      }
    }
  },

  crated() {
    this.open = this.dialog
  },

  mounted() {
    this.open = this.dialog
    if (this.options.target === 'wallheaven') {
      this.isLoadingTags = true

      this.wallheavenTags()

      this.isLoadingTags = false
    }
  },

  methods: {
    async wallheavenTags() {
      const params = {
        id: this.pictureDetails.id
      }

      const request = await wallheavenTags.get('', { params: { ...params } })

      this.pictureDetails.tags = request.data
    },

    closeDialog() {
      this.open = false
      this.$emit('closeDetails')
    },

    moreLikeThis(id) {
      this.closeDialog()
      const text = `like:${id}`
      this.$root.$emit('updateSearchText', text)
      this.$emit('runSearch', text)
    },

    searchByTag(tag) {
      this.closeDialog()
      this.$root.$emit('updateSearchText', tag)
      this.$emit('runSearch', tag)
    }
  }
}
</script>

<style
  scoped
  lang="scss"
>
.detailsCard {
  width: 600px;
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  background-color: rgba(17, 25, 40, 0.75);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.125);

  &__title {
    display: flex;
    font-size: 50px;

    &--text {
      color: white;
      width: 100%;
      padding-left: 30px;
      padding-top: 13px;
      font-style: italic;
    }
  }

  &__close {
    align-items: start;
  }

  &__list {
    background-color: transparent;
  }
}

.tagsItems {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-height: 100vh;
}
</style>
